import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import HowItWorksFlow, { stageShape } from './howItWorksFlow';

export default function HowItWorksEmptyState({
  title,
  subtitle = '',
  stages,
  actionLabel = 'Começar',
  onAction = null,
}) {
  return (
    <Box sx={{ py: 3, px: { xs: 0, md: 2 } }}>
      <Typography variant="h6" align="center" sx={{ fontWeight: 'bold' }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}

      <Box sx={{ mt: 3, maxWidth: 560, mx: 'auto' }}>
        <HowItWorksFlow stages={stages} />
      </Box>

      {onAction && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
          <Button variant="contained" disableElevation onClick={onAction}>
            {actionLabel}
          </Button>
        </Box>
      )}
    </Box>
  );
}

HowItWorksEmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  stages: PropTypes.arrayOf(stageShape).isRequired,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
};
